import {
  Button,
  Flex,
  Grid,
  SelectField,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";

const ROLE_OPTIONS = [
  "",
  "Agrónomo",
  "Mayordomo",
  "Operario Cultivo",
  "Técnico",
  "Otro",
];
const CONTRACT_TYPES = ["", "Indefinido", "Servicios", "Obra o Labor", "Otro"];
const STATUS_OPTIONS = ["", "Activo", "Inactivo"];

const CollaboratorForm = ({
  onSubmit,
  type = "create",
  initialValues = {},
  onCancel,
}) => {
  const defaultState = {
    name: "",
    role: "",
    startDate: "",
    contractType: "",
    status: "",
    photo: "",
    cv: "",
    affiliations: "",
    createdAt: "",
  };

  const [form, setForm] = useState({ ...defaultState, ...initialValues });

  useEffect(() => {
    setForm({ ...defaultState, ...initialValues });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);

  const onSubmitForm = () => {
    onSubmit && onSubmit(form);
  };

  return (
    <Grid rowGap="15px" columnGap="15px" padding="20px">
      <Grid gap="15px" templateColumns={{ base: "1fr", large: "2fr 2fr" }}>
        <TextField
          name="name"
          label={strings.fields.name.label}
          value={form.name || ""}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
        />
        <SelectField
          name="role"
          label={strings.fields.role.label}
          value={form.role || ""}
          onChange={(e) => setForm({ ...form, role: e.target.value })}
        >
          {ROLE_OPTIONS.map((r) => (
            <option key={r} value={r}>
              {r || "--"}
            </option>
          ))}
        </SelectField>
      </Grid>

      <Grid gap="15px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <TextField
          name="startDate"
          label={strings.fields.startDate.label}
          placeholder="YYYY-MM-DD"
          value={form.startDate || ""}
          onChange={(e) => setForm({ ...form, startDate: e.target.value })}
        />
        <SelectField
          name="contractType"
          label={strings.fields.contractType.label}
          value={form.contractType || ""}
          onChange={(e) => setForm({ ...form, contractType: e.target.value })}
        >
          {CONTRACT_TYPES.map((c) => (
            <option key={c} value={c}>
              {c || "--"}
            </option>
          ))}
        </SelectField>
      </Grid>

      <Grid gap="15px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <SelectField
          name="status"
          label={strings.fields.status.label}
          value={form.status || ""}
          onChange={(e) => setForm({ ...form, status: e.target.value })}
        >
          {STATUS_OPTIONS.map((s) => (
            <option key={s} value={s}>
              {s || "--"}
            </option>
          ))}
        </SelectField>

        <TextField
          name="photo"
          label={strings.fields.photo.label}
          value={form.photo || ""}
          onChange={(e) => setForm({ ...form, photo: e.target.value })}
        />
      </Grid>

      <TextField
        name="cv"
        label={strings.fields.cv.label}
        value={form.cv || ""}
        onChange={(e) => setForm({ ...form, cv: e.target.value })}
      />

      <TextAreaField
        name="affiliations"
        label={strings.fields.affiliations.label}
        placeholder='Ej: {"date":"2024-01-01","name":"EPS X","filePdf":"afiliacion.pdf"} o "Afiliacion1, Afiliacion2"'
        value={form.affiliations || ""}
        onChange={(e) => setForm({ ...form, affiliations: e.target.value })}
      />

      <Flex justifyContent="end">
        <Button
          children={strings.fields.buttons.reset}
          onClick={() => setForm(defaultState)}
        />
        <Button
          children={
            type === "create"
              ? strings.fields.buttons.create
              : strings.fields.buttons.save
          }
          onClick={onSubmitForm}
          variation="primary"
        />
      </Flex>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    fields: {
      name: { label: "Nombre" },
      role: { label: "Cargo" },
      startDate: { label: "Fecha de ingreso" },
      contractType: { label: "Tipo de Contrato" },
      status: { label: "Estado" },
      photo: { label: "Foto" },
      cv: { label: "Hoja de Vida" },
      affiliations: { label: "Afiliaciones" },
      buttons: {
        create: "Crear",
        save: "Guardar",
        reset: "Restablecer",
        cancel: "Cancelar",
      },
    },
  },
});

export default CollaboratorForm;
